"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require("./create");
exports.createModalManager = create_1.createModalManager;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-manager/dist/index.js
// module id = 2486
// module chunks = 0